<template>
  <div id="editor" ref="editor">
    <vue-editor class="bg-white"
      v-model="editorText"
      :editorToolbar="customToolbar"
    ></vue-editor>
    <button :id="['commitbutton'] + uniqueid" @click="onEditorBlur" class="btn block mt-2 text-xl"><i aria-hidden="true" class="material-icons align-bottom text-3xl">save</i> {{ buttontext }}</button>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import axios from 'axios'
import editorA11yLabels from '../mixins/editor-a11y-labels.js'

export default {
  mixins: [ editorA11yLabels ],

  props: {
    route:'',
    routeparam:'',
    initialvalue: '',
    buttontext: '',
    uniqueid:'',
  },
  components: {
    VueEditor
  },
  data() {
    return {
      buttonid: this.uniqueid,
      editorText: this.initialvalue,
      content: this.initialvalue,
      customToolbar: [
        [{ 'header': [false, 2, 3, 4, ] }],
        ["bold", "italic", "underline"],
        ['blockquote'],
        [{'align': ''}, {'align': 'center'}, {'align': 'right'}],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ 'indent': '-1'}, { 'indent': '+1' }],
        [{ 'color': [] }, { 'background': [] }],
        // ['link', 'image'],
        ['clean'],
      ]
    }
  },
  methods: {
      onEditorBlur() {
        const commitButton = '#commitbutton' + this.uniqueid;
          $( commitButton ).addClass( "loading" ).removeClass( "success" );
          axios.put(
                this.route,{ [this.routeparam]: this.editorText }
              ).then(function (response) {
                console.log(response);
              }).then(function (success) {
                  $( commitButton ).removeClass( "loading" ).addClass( "success");
                })
      },
  },
};
</script>
<style type="text/css">
  .ql-align-center {
    text-align: center;
  }
  .ql-align-right {
    text-align: right;
  }
</style>
